<template>
  <v-card :style="backOpacity">
    <v-card-title>自動スクロール機能 AutoScroll.vue</v-card-title>
    <v-card-text>
      rules:{{ rules }}
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rule0flag"
                label="レポート更新の際、特定フォームまで移動"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="rule0flag">
              <v-text-field
                label="移動先formID"
                v-model="rule0formID"
                hint="指定したformにidが生成されている場合のみ有効です"
                :rules="[varidation.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        rule: this.rule,
      },

      showButton: false,
      backOpacity: "opacity: 1",
      rules: [0],
      rule0flag: false,
      rule0formID: "",

      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        numANDNot: (value) => {
          return /^[&!:0-9]*$/.test(value) || "数値か!のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  async mounted() {
    //送信ボタンのカクツキ防止
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    await this.getInit();
    //初期処理
  },
  methods: {
    async getInit() {
      if (typeof this.rule != "undefined") {
        this.rules = this.rule.split(",");

        if (this.nullCheck(this.rules[0])) {
          this.rule0flag = true;
          this.rule0formID = this.rules[0];
        }
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.rule0flag) {
          this.rules[0] = this.rule0formID;
        } else {
          this.rules[0] = "";
        }

        this.returnData.rule = this.rules.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
    /* false undefined の時にfalseを返す。trueや"true"はtrueを返す */
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
  },
};
</script>
